@if (displayName(); as name) {
  <button
    hlmBtn
    variant="ghost"
    size="icon-sm"
    type="button"
    class="rounded-full"
    [hlmDropdownMenuTrigger]="menu"
    align="end"
    [attr.aria-label]="'menu.profileMenu' | translate"
    data-cy="user-menu-trigger">
    <hlm-avatar size="sm">
      <span hlmAvatarFallback class="text-[10px] font-medium">{{ initials() }}</span>
    </hlm-avatar>
  </button>

  <ng-template #menu>
    <hlm-dropdown-menu class="w-64" data-cy="user-menu">
      <div class="flex items-center gap-2 px-2 py-1.5">
        <hlm-avatar>
          <span hlmAvatarFallback class="text-xs font-medium">{{ initials() }}</span>
        </hlm-avatar>
        <div class="grid min-w-0 leading-tight">
          <span class="truncate text-sm font-medium">{{ name }}</span>
          @if (email(); as mail) {
            <span class="text-muted-foreground truncate text-xs">{{ mail }}</span>
          }
        </div>
      </div>

      <hlm-dropdown-menu-separator />

      <hlm-dropdown-menu-group>
        <button hlmDropdownMenuItem (triggered)="toggleFullscreen()" data-cy="user-menu-fullscreen">
          @if (isFullscreen()) {
            <ng-icon name="lucideMinimize" />
            {{ 'menu.closeFullScreen' | translate }}
          } @else {
            <ng-icon name="lucideFullscreen" />
            {{ 'menu.fullScreen' | translate }}
          }
        </button>
        <button hlmDropdownMenuItem [hlmDropdownMenuSubTrigger]="languageMenu" data-cy="user-menu-language">
          <ng-icon name="lucideGlobe" />
          {{ 'menu.language' | translate }}
          <hlm-dropdown-menu-item-sub-indicator />
        </button>
        <a hlmDropdownMenuItem routerLink="/api-keys" data-cy="user-menu-api-keys">
          <ng-icon name="lucideKeyRound" />
          {{ 'menu.apiKeys' | translate }}
        </a>
      </hlm-dropdown-menu-group>

      @if (getStartedLink() || suggestionLink() || reportBugLink()) {
        <hlm-dropdown-menu-separator />
        <hlm-dropdown-menu-group>
          @if (getStartedLink(); as href) {
            <a hlmDropdownMenuItem [href]="href" target="_blank" rel="noopener" data-cy="user-menu-get-started">
              <ng-icon name="lucideBookOpen" />
              {{ 'menu.getStarted' | translate }}
            </a>
          }
          @if (suggestionLink(); as href) {
            <a hlmDropdownMenuItem [href]="href" target="_blank" rel="noopener" data-cy="user-menu-suggestion">
              <ng-icon name="lucideLightbulb" />
              {{ 'menu.suggestion' | translate }}
            </a>
          }
          @if (reportBugLink(); as href) {
            <a hlmDropdownMenuItem [href]="href" target="_blank" rel="noopener" data-cy="user-menu-report-bug">
              <ng-icon name="lucideBug" />
              {{ 'menu.reportBug' | translate }}
            </a>
          }
        </hlm-dropdown-menu-group>
      }

      <hlm-dropdown-menu-separator />

      <div class="flex items-center gap-1.5 py-1 ps-1.5 pe-1 text-sm" data-cy="user-menu-theme">
        <ng-icon name="lucidePalette" class="text-muted-foreground text-base" aria-hidden="true" />
        <span id="user-menu-theme-label" class="flex-1">{{ 'menu.theme' | translate }}</span>
        <hlm-toggle-group
          type="single"
          size="sm"
          class="bg-muted rounded-lg p-[3px]"
          aria-labelledby="user-menu-theme-label"
          [value]="theme()"
          (valueChange)="setTheme($event)">
          @for (option of themes; track option.value) {
            <button
              hlmToggleGroupItem
              type="button"
              [value]="option.value"
              class="text-muted-foreground data-[state=on]:bg-background data-[state=on]:text-foreground h-[22px] min-w-[22px] rounded-md border-0 px-0 data-[state=on]:shadow-sm"
              [attr.aria-label]="option.labelKey | translate"
              [attr.data-cy]="'user-menu-theme-' + option.value">
              <ng-icon [name]="option.icon" class="text-sm" />
            </button>
          }
        </hlm-toggle-group>
      </div>

      <hlm-dropdown-menu-separator />

      <button hlmDropdownMenuItem variant="destructive" (triggered)="logout()" data-cy="user-menu-sign-out">
        <ng-icon name="lucideLogOut" />
        {{ 'app.logout' | translate }}
      </button>
    </hlm-dropdown-menu>
  </ng-template>

  <ng-template #languageMenu>
    <hlm-dropdown-menu-sub class="w-36" data-cy="user-menu-languages">
      @for (option of languages; track option.value) {
        <button
          hlmDropdownMenuRadio
          [checked]="language() === option.value"
          (triggered)="setLanguage(option.value)"
          [attr.data-cy]="'user-menu-language-' + option.value">
          <img [src]="option.flag" alt="" class="h-3 w-4 rounded-[2px]" />
          {{ option.label }}
          <hlm-dropdown-menu-radio-indicator />
        </button>
      }
    </hlm-dropdown-menu-sub>
  </ng-template>
}
